<template>
  <v-card outlined max-width="380" class="mb-5">
    <v-card-subtitle class="pb-1">
      <span class="text-subtitle-2">日本語校正サポート（β版）</span>
      <div>
        <v-btn
          v-if="!isTextLintProcessing"
          color="primary"
          class="font-weight-bold"
          small
          @click="execute"
          >記事全体をチェックする</v-btn
        >
        <v-btn v-else class="font-weight-bold" small disabled
          >チェックを実行中</v-btn
        >
      </div>
    </v-card-subtitle>
    <v-card-actions class="pl-3">
      <span class="text-overline">機能の詳細</span>
      <v-spacer></v-spacer>

      <v-btn icon small @click="showDetail = !showDetail">
        <v-icon>{{
          showDetail ? 'mdi-chevron-up' : 'mdi-chevron-down'
        }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-text class="caption pt-0">
      <div v-if="showDetail">
        <p>
          こちらの機能では、各アイテムの保存が行われた際に自動でチェックが行われます。<br />
          記事全体のチェックを行いたい場合は、上記の「記事全体をチェックする」ボタンを押してください。<br />
          チェックが行われると、事前に設定されたルールを元に、ルールが守られていない部分が赤くハイライトされます。<br />
          そして、ハイライトされた箇所にカーソルを合わせるとすると詳細な説明が表示されます。<br />
        </p>
        <p>
          なお、ハイライト箇所は自動では修正されず、注意していただきたい箇所の表示のみとなります。<br />
          チェックを完全に通過しなくとも、通常の記事の執筆やレギュレーションチェック、記事の納品は可能となっております。
        </p>

        <p>機能やルールの詳細は <a href="https://support.b-cms.jp/48" target='_blank'>こちら</a>をご覧ください。</p>
        <p>
          ※こちらの機能はβ版のため、今後の仕様の変更を行う可能性がございます。また、記事を保存することによって、アイテム内の校正部分のハイライトが消えることがあります。
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ProofreadBtn',
  data () {
    return {
      splitChunk: 15,
      interval: 10000,
      showDetail: false,
      isTextLintProcessing: false
    }
  },
  methods: {
    execute () {
      this.isTextLintProcessing = true
      this.$store
        .dispatch(
          'TextLintStore/executeTextlintAction',
          this.splitChunk,
          this.interval
        )
        .finally(() => {
          this.isTextLintProcessing = false
        })
    }
  }
}
</script>
